import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAddLineupItem, useAuthFlow } from '@pkg/hooks';
import { useAppSelector } from '@pkg/hooks/redux/useAppSelector';

import { CollectionChainType } from '@app/client';
import { useFantasyTracking } from '@app/pages/FantasyWishlist/hooks';
import { useFantasyMetadataStore } from '@app/store/zustand';
import { useFantasyLandingAutoGeneratedLineupStore } from '@app/store/zustand/FantasyLanding/AutoGeneratedLineup';

export const useAddAutogeneratedLineup = () => {
    const addLineupItem = useAddLineupItem();

    const autoGeneratedLineup = useFantasyLandingAutoGeneratedLineupStore((state) => state.autoGeneratedLineup);
    const clearLineup = useFantasyLandingAutoGeneratedLineupStore((state) => state.clearLineup);
    const currentGame = useFantasyMetadataStore((state) => state.currentGame);
    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);

    useEffect(() => {
        if (currentGame && autoGeneratedLineup?.length && isRegisteredUser) {
            autoGeneratedLineup.forEach((collection) => {
                if (collection.slug && collection.quantity) {
                    addLineupItem(
                        {
                            collectionSlug: collection.slug,
                            quantity: collection.quantity,
                            chain: CollectionChainType.Ethereum,
                        },
                        { isUpdate: false, isAutoPicked: false, isConfirmed: false },
                    );
                }
            });
            clearLineup();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoGeneratedLineup, currentGame, isRegisteredUser]);
};

export const useAutogeneratedFantasySubmit = () => {
    const navigate = useNavigate();
    const activeGame = useFantasyLandingAutoGeneratedLineupStore((state) => state.activeGame);
    const [submitted, setSubmitted] = useState(false);
    const { trackNavFantasyClick } = useFantasyTracking();
    const { protectedAction } = useAuthFlow();

    const handleSubmit = () => {
        protectedAction(async () => {
            setSubmitted(true);
            if (activeGame) {
                trackNavFantasyClick(activeGame.id, activeGame.slug, 'fantasy-landing-play-button');
                navigate(`/fantasy/${activeGame.slug}`);
            } else {
                trackNavFantasyClick('Not loaded', 'Not loaded', 'fantasy-landing-play-button');
                navigate(`/fantasy`);
            }
        });
    };
    return {
        submitted,
        handleSubmit,
    };
};
